export const IconFacebook = ({ width, height, fill }) => {
  return (
    <svg width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="url(#paint0_linear_551_13004)" />
      <path
        opacity="0.9"
        d="M17.0089 23.6571V16.8804H19.2768L19.625 14.2375H17.0089V12.55C17.0089 12.1214 17.0982 11.8 17.2768 11.5857C17.4554 11.3714 17.8006 11.2643 18.3125 11.2643H19.7143V8.90715C19.2321 8.83572 18.5536 8.8 17.6786 8.8C16.6488 8.8 15.8244 9.10506 15.2054 9.71518C14.5863 10.3253 14.2768 11.1839 14.2768 12.2911V14.2375H12V16.8804H14.2768V23.6571H17.0089Z"
        fill="white"
      />
      <defs>
        <linearGradient id="paint0_linear_551_13004" x1="-16" y1="16" x2="16" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3B5998" />
          <stop offset="1" stopColor="#6085D1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const IconClubhouse = ({ width, height, fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="16" fill="#FFE450" />
      <g clip-path="url(#a)">
        <path
          fill="#1F1F1A"
          d="M11.575 14.631c.238.746.527 1.447.84 2.122.539 1.21.902 1.849 1.405 2.642.614.948 1.291 2.027 2.407 2.726.814.51 1.805.77 2.758.77a4.968 4.968 0 0 0 3.235-1.21c.727-.639 1.668-1.872 1.668-4.278 0-.829.389-1.54.677-2.11 0-.011.012-.035.037-.082.113-.237.251-.545.251-.853a1.22 1.22 0 0 0-.226-.711c-.25-.403-.701-.545-1.116-.545-.965 0-1.63.64-1.969 1.292l-.112.213c-.138-.189-.276-.39-.389-.568-.35-.58-.551-.971-.727-1.47a9.555 9.555 0 0 1-.326-1.21c-.213-1.162-.564-1.54-1.141-1.683a1.753 1.753 0 0 0-1.292.202c-.25-.533-.675-.77-1.24-.77-.803 0-1.53.497-1.53 1.34 0 .106.012.213.024.343a1.442 1.442 0 0 0-.325-.036c-.865 0-1.505.569-1.505 1.34 0 .178.025.38.087.616-.075-.012-.15-.012-.225-.012-.426.024-.815.178-1.091.498-.275.308-.388.782-.175 1.434Z"
        />
        <path
          fill="#FFE450"
          d="M12.29 14.418c-.113-.343-.1-.604.037-.77.138-.154.326-.225.552-.237.388-.012.538.249.764.924.138.426.413 1.044.576 1.387.213.415.514.972.652 1.162.113.166.213.213.326.213.2 0 .35-.106.35-.296 0-.106-.112-.284-.175-.39-.113-.202-.35-.605-.514-.948-.175-.38-.376-.853-.538-1.28-.1-.25-.213-.605-.326-.96-.176-.545-.263-.877-.263-1.127 0-.379.3-.628.752-.628.325 0 .538.154.676.711.113.51.313 1.34.602 1.991.188.427.463.996.626 1.28.1.167.213.309.213.368 0 .083-.163.213-.3.39-.088.108-.126.179-.126.262 0 .07.05.142.126.236.075.095.15.19.238.19.062 0 .1-.024.138-.071a4.272 4.272 0 0 1 1.304-1.044c.576-.308 1.167-.462 1.63-.556.226-.048.288-.095.288-.214 0-.142-.112-.225-.263-.236-.113-.012-.213 0-.388.011-.125.012-.188-.047-.263-.201-.226-.45-.665-1.21-.928-2.18a8.875 8.875 0 0 1-.275-1.423c-.038-.261.012-.356.15-.474.175-.142.489-.202.727-.142.288.07.438.284.589 1.114.075.391.2.889.35 1.316.189.545.427.996.79 1.6.2.332.451.676.715 1.008-.05.143-.138.237-.427.463-.288.224-.576.461-.84.9-.187.32-.275.675-.275.912 0 .225.05.272.2.272.264 0 .477-.047.49-.154.062-.426.137-.698.388-1.02.15-.177.413-.402.626-.58.402-.308.54-.486.677-.924.063-.201.138-.39.238-.569.238-.414.664-.888 1.33-.888.213 0 .388.06.501.225a.617.617 0 0 1 .088.32c0 .213-.163.51-.238.651-.276.557-.727 1.411-.727 2.395 0 2.145-.802 3.212-1.43 3.757a4.156 4.156 0 0 1-2.72 1.02 4.525 4.525 0 0 1-2.345-.652c-.965-.604-1.568-1.553-2.182-2.5-.488-.77-.827-1.376-1.354-2.549a23.153 23.153 0 0 1-.813-2.065Z"
        />
        <path
          fill="#FFE450"
          d="M15.512 10.447c0-.45.44-.627.802-.627.389 0 .527.177.627.556.088.308.125.593.163.924.05.332.226 1.091.276 1.28.188.652.564 1.423 1.015 2.347a6.663 6.663 0 0 0-.852.344c-.301.154-.364.154-.49-.071-.262-.462-.45-.806-.613-1.21a8.418 8.418 0 0 1-.389-1.15c-.188-.746-.213-.96-.363-1.304-.088-.354-.176-.793-.176-1.089Z"
        />
        <path
          fill="#1F1F1A"
          d="M11.024 18.382c-.266.155-1.673.852-1.99.963-.227.08-.473.06-.618-.345-.178-.5.072-.619.427-.75.315-.114 1.62-.56 1.922-.638.213-.054.361.014.464.257.113.265.035.372-.205.513ZM9.864 15.56c-.378.01-1.95-.054-2.308-.088-.312-.029-.439-.16-.405-.587.037-.458.226-.486.532-.458.356.032 2.002.285 2.264.362.271.08.309.196.276.42-.042.29-.181.345-.359.35ZM10.059 12.553c-.433-.13-1.718-.865-2.053-1.055-.303-.172-.342-.327-.131-.705.187-.334.394-.392.702-.241.356.175 1.615 1.101 1.855 1.285.233.176.201.268.08.495-.123.227-.237.285-.453.22Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M7 9h18v14H7z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconTiktok = ({ width, height, fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="16" fill="#fff" />
      <path fill="#25F4EE" d="M14.51 14.733v-.617a4.556 4.556 0 0 0-.646-.056 4.798 4.798 0 0 0-2.75 8.737 4.792 4.792 0 0 1 3.397-8.064Z" />
      <path
        fill="#25F4EE"
        d="M14.627 21.72a2.194 2.194 0 0 0 2.19-2.098V9.162h1.91a3.578 3.578 0 0 1-.055-.663h-2.614v10.45a2.194 2.194 0 0 1-2.19 2.113 2.223 2.223 0 0 1-1.01-.252 2.194 2.194 0 0 0 1.77.91Zm7.67-9.01v-.581a3.57 3.57 0 0 1-1.977-.597 3.624 3.624 0 0 0 1.977 1.178Z"
      />
      <path
        fill="#FE2C55"
        d="M20.32 11.532a3.6 3.6 0 0 1-.895-2.376h-.698a3.62 3.62 0 0 0 1.593 2.376Zm-6.456 5.142a2.195 2.195 0 0 0-1.012 4.136 2.19 2.19 0 0 1 1.775-3.474c.22.003.438.037.647.102v-2.66a4.58 4.58 0 0 0-.647-.05h-.116v2.022a2.247 2.247 0 0 0-.647-.076Z"
      />
      <path
        fill="#FE2C55"
        d="M22.297 12.71v2.023a6.203 6.203 0 0 1-3.625-1.178v5.313a4.808 4.808 0 0 1-4.808 4.798 4.757 4.757 0 0 1-2.75-.87 4.798 4.798 0 0 0 8.311-3.265v-5.299a6.214 6.214 0 0 0 3.63 1.163v-2.604a3.71 3.71 0 0 1-.758-.08Z"
      />
      <path
        fill="#000"
        d="M18.672 18.868v-5.313a6.203 6.203 0 0 0 3.63 1.162v-2.022a3.625 3.625 0 0 1-1.982-1.163 3.62 3.62 0 0 1-1.593-2.376h-1.91v10.466a2.194 2.194 0 0 1-3.97 1.198 2.194 2.194 0 0 1 1.011-4.136c.22.002.438.036.648.101v-2.022a4.792 4.792 0 0 0-3.398 8.09 4.758 4.758 0 0 0 2.756.813 4.808 4.808 0 0 0 4.808-4.798Z"
      />
    </svg>
  );
};

export const IconMsgSend = ({ width, height, fill }) => {
  return (
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.73127 0.90871L3.83678 6.82989C3.61089 7.05695 3.24514 7.05666 3.01954 6.8293L0.0845456 3.87418C-0.0281819 3.76058 -0.0281819 3.57596 0.0845456 3.46236L0.493602 3.05082C0.606329 2.93722 0.789493 2.93722 0.902366 3.05082L3.23129 5.39579C3.34402 5.50939 3.52718 5.50939 3.64005 5.39579L8.91418 0.0852018C9.02691 -0.0284006 9.21007 -0.0284006 9.32294 0.0852018L9.73171 0.496737C9.84473 0.610777 9.84443 0.795107 9.73127 0.90871Z"
        fill="white"
      />
    </svg>
  );
};
export const IconMsgReceive = ({ width, height, fill }) => {
  return (
    <svg width="15" height="7" viewBox="0 0 15 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.83678 6.82989L9.73127 0.90871C9.84443 0.795107 9.84473 0.610777 9.73171 0.496737L9.32294 0.0852018C9.21007 -0.0284006 9.02691 -0.0284006 8.91418 0.0852018L3.64005 5.39579C3.52718 5.50939 3.34402 5.50939 3.23129 5.39579L0.902366 3.05082C0.789493 2.93722 0.606329 2.93722 0.493602 3.05082L0.0845456 3.46236C-0.0281819 3.57596 -0.0281819 3.76058 0.0845456 3.87418L3.01954 6.8293C3.24514 7.05666 3.61089 7.05695 3.83678 6.82989ZM13.8051 0.0853476L14.2078 0.496883C14.3191 0.610485 14.3191 0.795107 14.2073 0.908564L8.39896 6.82974C8.17656 7.0568 7.81592 7.05651 7.59382 6.82916L6.57928 5.79274C6.46786 5.67884 6.46815 5.49422 6.57957 5.38062L6.98294 4.96967C7.09435 4.85606 7.2746 4.85636 7.38572 4.96996L7.80236 5.39579C7.91378 5.50939 8.09402 5.50939 8.20544 5.39579L13.4023 0.0853476C13.5134 -0.0282548 13.6939 -0.0282548 13.8051 0.0853476Z"
        fill="white"
      />
    </svg>
  );
};
export const IconMsgRead = ({ width, height, fill }) => {
  return (
    <svg width="15" height="7" viewBox="0 0 15 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.83678 6.82989L9.73127 0.90871C9.84443 0.795107 9.84473 0.610777 9.73171 0.496737L9.32294 0.0852018C9.21007 -0.0284006 9.02691 -0.0284006 8.91418 0.0852018L3.64005 5.39579C3.52718 5.50939 3.34402 5.50939 3.23129 5.39579L0.902366 3.05082C0.789493 2.93722 0.606329 2.93722 0.493602 3.05082L0.0845456 3.46236C-0.0281819 3.57596 -0.0281819 3.76058 0.0845456 3.87418L3.01954 6.8293C3.24514 7.05666 3.61089 7.05695 3.83678 6.82989ZM13.8051 0.0853476L14.2078 0.496883C14.3191 0.610485 14.3191 0.795107 14.2073 0.908564L8.39896 6.82974C8.17656 7.0568 7.81592 7.05651 7.59382 6.82916L6.57928 5.79274C6.46786 5.67884 6.46815 5.49422 6.57957 5.38062L6.98294 4.96967C7.09435 4.85606 7.2746 4.85636 7.38572 4.96996L7.80236 5.39579C7.91378 5.50939 8.09402 5.50939 8.20544 5.39579L13.4023 0.0853476C13.5134 -0.0282548 13.6939 -0.0282548 13.8051 0.0853476Z"
        fill="#19D100"
      />
    </svg>
  );
};

export const IconPhoto = ({ width, height, fill }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14.14 11.86L11.14 15.73L9 13.14L6 17H18L14.14 11.86Z"
        fill="white"
      />
    </svg>
  );
};

export const IconVideo = ({ width, height, fill }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.15 6.17C20.74 5.95 19.88 5.72 18.71 6.54L17.24 7.58C17.13 4.47 15.78 3.25 12.5 3.25H6.5C3.08 3.25 1.75 4.58 1.75 8V16C1.75 18.3 3 20.75 6.5 20.75H12.5C15.78 20.75 17.13 19.53 17.24 16.42L18.71 17.46C19.33 17.9 19.87 18.04 20.3 18.04C20.67 18.04 20.96 17.93 21.15 17.83C21.56 17.62 22.25 17.05 22.25 15.62V8.38C22.25 6.95 21.56 6.38 21.15 6.17ZM11 11.38C9.97 11.38 9.12 10.54 9.12 9.5C9.12 8.46 9.97 7.62 11 7.62C12.03 7.62 12.88 8.46 12.88 9.5C12.88 10.54 12.03 11.38 11 11.38Z"
        fill="white"
      />
    </svg>
  );
};

export const Iconaudio = ({ width, height, fill }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.12 9.11999C18.73 9.11999 18.42 9.42999 18.42 9.81999V11.4C18.42 14.94 15.54 17.82 12 17.82C8.45999 17.82 5.57999 14.94 5.57999 11.4V9.80999C5.57999 9.41999 5.26999 9.10999 4.87999 9.10999C4.48999 9.10999 4.17999 9.41999 4.17999 9.80999V11.39C4.17999 15.46 7.30999 18.81 11.3 19.17V21.3C11.3 21.69 11.61 22 12 22C12.39 22 12.7 21.69 12.7 21.3V19.17C16.68 18.82 19.82 15.46 19.82 11.39V9.80999C19.81 9.42999 19.5 9.11999 19.12 9.11999Z"
        fill="white"
      />
      <path
        d="M12 2C9.56002 2 7.58002 3.98 7.58002 6.42V11.54C7.58002 13.98 9.56002 15.96 12 15.96C14.44 15.96 16.42 13.98 16.42 11.54V6.42C16.42 3.98 14.44 2 12 2ZM13.31 8.95C13.24 9.21 13.01 9.38 12.75 9.38C12.7 9.38 12.65 9.37 12.6 9.36C12.21 9.25 11.8 9.25 11.41 9.36C11.09 9.45 10.78 9.26 10.7 8.95C10.61 8.64 10.8 8.32 11.11 8.24C11.7 8.08 12.32 8.08 12.91 8.24C13.21 8.32 13.39 8.64 13.31 8.95ZM13.84 7.01C13.75 7.25 13.53 7.39 13.29 7.39C13.22 7.39 13.16 7.38 13.09 7.36C12.39 7.1 11.61 7.1 10.91 7.36C10.61 7.47 10.27 7.31 10.16 7.01C10.05 6.71 10.21 6.37 10.51 6.27C11.47 5.92 12.53 5.92 13.49 6.27C13.79 6.38 13.95 6.71 13.84 7.01Z"
        fill="white"
      />
    </svg>
  );
};

export const IconLocation = ({ width, height, fill }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.62 8.45C19.57 3.83 15.54 1.75 12 1.75C12 1.75 12 1.75 11.99 1.75C8.45997 1.75 4.41997 3.82 3.36997 8.44C2.19997 13.6 5.35997 17.97 8.21997 20.72C9.27997 21.74 10.64 22.25 12 22.25C13.36 22.25 14.72 21.74 15.77 20.72C18.63 17.97 21.79 13.61 20.62 8.45ZM12 13.46C10.26 13.46 8.84997 12.05 8.84997 10.31C8.84997 8.57 10.26 7.16 12 7.16C13.74 7.16 15.15 8.57 15.15 10.31C15.15 12.05 13.74 13.46 12 13.46Z"
        fill="white"
      />
    </svg>
  );
};

export const IconPlayaudio = ({ width, height, fill }) => {
  return (
    <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.799988 0.400002V11.6L9.59999 6L0.799988 0.400002Z" fill="white" />
    </svg>
  );
};

export const IconOnline = ({ width, height, fill }) => {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="4" cy="4" r="3.5" fill="#19D100" stroke="white" />
    </svg>
  );
};

export const IconMarkAsUnread = ({ width, height, fill }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.5 8C20.8807 8 22 6.88071 22 5.5C22 4.11929 20.8807 3 19.5 3C18.1193 3 17 4.11929 17 5.5C17 6.88071 18.1193 8 19.5 8Z" fill="white" />
      <path d="M19.5 8C20.8807 8 22 6.88071 22 5.5C22 4.11929 20.8807 3 19.5 3C18.1193 3 17 4.11929 17 5.5C17 6.88071 18.1193 8 19.5 8Z" fill="white" />
      <path
        d="M20.72 9.31C20.02 9.53 19.25 9.57 18.45 9.37C17.11 9.02 16.02 7.95 15.65 6.61C15.47 5.96 15.46 5.32 15.57 4.74C15.7 4.1 15.25 3.5 14.61 3.5H7C4 3.5 2 5 2 8.5V15.5C2 19 4 20.5 7 20.5H17C20 20.5 22 19 22 15.5V10.26C22 9.6 21.36 9.1 20.72 9.31ZM15.52 11.15L14.34 12.09C13.68 12.62 12.84 12.88 12 12.88C11.16 12.88 10.31 12.62 9.66 12.09L6.53 9.59C6.21 9.33 6.16 8.85 6.41 8.53C6.67 8.21 7.14 8.15 7.46 8.41L10.59 10.91C11.35 11.52 12.64 11.52 13.4 10.91L14.58 9.97C14.9 9.71 15.38 9.76 15.63 10.09C15.89 10.41 15.84 10.89 15.52 11.15Z"
        fill={fill || 'white'}
      />
    </svg>
  );
};

export const IconDeleteChat = ({ width, height, fill }) => {
  return (
    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 19C5 20.1 5.9 21 7 21H15C16.1 21 17 20.1 17 19V9C17 7.9 16.1 7 15 7H7C5.9 7 5 7.9 5 9V19ZM17 4H14.5L13.79 3.29C13.61 3.11 13.35 3 13.09 3H8.91C8.65 3 8.39 3.11 8.21 3.29L7.5 4H5C4.45 4 4 4.45 4 5C4 5.55 4.45 6 5 6H17C17.55 6 18 5.55 18 5C18 4.45 17.55 4 17 4Z"
        fill={fill || 'white'}
      />
    </svg>
  );
};

export const IconRecord = ({ width, height, fill }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.1201 9.11999C18.7301 9.11999 18.4201 9.42999 18.4201 9.81999V11.4C18.4201 14.94 15.5401 17.82 12.0001 17.82C8.46005 17.82 5.58005 14.94 5.58005 11.4V9.80999C5.58005 9.41999 5.27005 9.10999 4.88005 9.10999C4.49005 9.10999 4.18005 9.41999 4.18005 9.80999V11.39C4.18005 15.46 7.31005 18.81 11.3001 19.17V21.3C11.3001 21.69 11.6101 22 12.0001 22C12.3901 22 12.7001 21.69 12.7001 21.3V19.17C16.6801 18.82 19.8201 15.46 19.8201 11.39V9.80999C19.8101 9.42999 19.5001 9.11999 19.1201 9.11999Z"
        fill="white"
      />
      <path
        d="M12 2C9.55996 2 7.57996 3.98 7.57996 6.42V11.54C7.57996 13.98 9.55996 15.96 12 15.96C14.44 15.96 16.42 13.98 16.42 11.54V6.42C16.42 3.98 14.44 2 12 2ZM13.31 8.95C13.24 9.21 13.01 9.38 12.75 9.38C12.7 9.38 12.65 9.37 12.6 9.36C12.21 9.25 11.8 9.25 11.41 9.36C11.09 9.45 10.78 9.26 10.7 8.95C10.61 8.64 10.8 8.32 11.11 8.24C11.7 8.08 12.32 8.08 12.91 8.24C13.21 8.32 13.39 8.64 13.31 8.95ZM13.84 7.01C13.75 7.25 13.53 7.39 13.29 7.39C13.22 7.39 13.16 7.38 13.09 7.36C12.39 7.1 11.61 7.1 10.91 7.36C10.61 7.47 10.27 7.31 10.16 7.01C10.05 6.71 10.21 6.37 10.51 6.27C11.47 5.92 12.53 5.92 13.49 6.27C13.79 6.38 13.95 6.71 13.84 7.01Z"
        fill="white"
      />
    </svg>
  );
};

export const IconBlock = ({ width, height, fill }) => {
  return (
    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 2C5.48 2 1 6.48 1 12C1 17.52 5.48 22 11 22C16.52 22 21 17.52 21 12C21 6.48 16.52 2 11 2ZM3 12C3 7.58 6.58 4 11 4C12.85 4 14.55 4.63 15.9 5.69L4.69 16.9C3.63 15.55 3 13.85 3 12ZM11 20C9.15 20 7.45 19.37 6.1 18.31L17.31 7.1C18.37 8.45 19 10.15 19 12C19 16.42 15.42 20 11 20Z"
        fill={fill || 'white'}
      />
    </svg>
  );
};

export const IconBandcamp = ({ width, height, fill }) => {
  return (
    <svg width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="#6399A8" />
      <path d="M18.5433 20H9L13.4566 12H23L18.5433 20Z" fill="white" />
    </svg>
  );
};

export const IconSoundcloud = ({ width, height, fill }) => {
  return (
    <svg width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="url(#paint0_linear_430_215)" />
      <path
        d="M7 19.2047C7 19.4284 7.08098 19.5976 7.24291 19.7122C7.40484 19.8269 7.57794 19.8674 7.76221 19.8339C7.93531 19.8003 8.05677 19.7388 8.12658 19.6493C8.19637 19.5598 8.23129 19.4116 8.23129 19.2047V16.7718C8.23129 16.5984 8.17127 16.4516 8.0512 16.3314C7.93116 16.2111 7.78458 16.151 7.61147 16.151C7.44395 16.151 7.30016 16.2111 7.1801 16.3314C7.06004 16.4516 7 16.5984 7 16.7718V19.2047ZM8.92648 20.2449C8.92648 20.4072 8.98372 20.5288 9.09818 20.6099C9.21266 20.691 9.35925 20.7315 9.53792 20.7315C9.72219 20.7315 9.87156 20.691 9.98604 20.6099C10.1005 20.5288 10.1577 20.4072 10.1577 20.2449V14.5738C10.1577 14.406 10.0977 14.262 9.97766 14.1418C9.8576 14.0215 9.71103 13.9614 9.53792 13.9614C9.37041 13.9614 9.2266 14.0215 9.10656 14.1418C8.9865 14.262 8.92648 14.406 8.92648 14.5738V20.2449ZM10.8446 20.5134C10.8446 20.6756 10.9032 20.7972 11.0205 20.8783C11.1377 20.9594 11.2885 21 11.4728 21C11.6515 21 11.798 20.9594 11.9125 20.8783C12.027 20.7972 12.0842 20.6756 12.0842 20.5134V15.3372C12.0842 15.1639 12.0242 15.0156 11.9042 14.8926C11.7841 14.7696 11.6403 14.7081 11.4728 14.7081C11.2997 14.7081 11.1517 14.7696 11.0289 14.8926C10.906 15.0156 10.8446 15.1639 10.8446 15.3372V20.5134H10.8446ZM12.7711 20.5386C12.7711 20.8462 12.9777 21 13.3909 21C13.8041 21 14.0107 20.8462 14.0107 20.5386V12.1493C14.0107 11.6795 13.8683 11.4139 13.5835 11.3523C13.3992 11.3076 13.2177 11.3607 13.0391 11.5117C12.8604 11.6627 12.771 11.8753 12.771 12.1493V20.5386H12.7711ZM14.7311 20.7818V11.6544C14.7311 11.3635 14.8176 11.1902 14.9907 11.1342C15.3648 11.0447 15.7362 11 16.1047 11C16.959 11 17.7548 11.2013 18.4919 11.604C19.2289 12.0067 19.825 12.5562 20.2801 13.2525C20.7352 13.9488 20.9991 14.7164 21.0717 15.5554C21.4123 15.41 21.7752 15.3372 22.1605 15.3372C22.9423 15.3372 23.611 15.6141 24.1666 16.1678C24.7222 16.7215 25 17.387 25 18.1644C25 18.9474 24.7222 19.6158 24.1666 20.1695C23.611 20.7232 22.9451 21 22.1689 21L14.8818 20.9916C14.8315 20.9748 14.7938 20.9441 14.7687 20.8993C14.7436 20.8546 14.7311 20.8154 14.7311 20.7818Z"
        fill="white"
      />
      <defs>
        <linearGradient id="paint0_linear_430_215" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF8800" />
          <stop offset="1" stopColor="#FF3300" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const IconYoutube = ({ width, height, fill }) => {
  return (
    <svg width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="url(#paint0_linear_551_13007)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0388 21.1723C19.6941 21.2741 18.0147 21.325 16.0004 21.325C14.8915 21.3143 13.9285 21.2969 13.1115 21.2728C12.2946 21.2487 11.7575 21.2286 11.5004 21.2125L11.1066 21.1804L10.8174 21.1482C10.6245 21.1214 10.4785 21.0946 10.3794 21.0679C10.2803 21.0411 10.1437 20.9848 9.96959 20.8991C9.79548 20.8134 9.64414 20.7036 9.51557 20.5696C9.48343 20.5375 9.44191 20.4879 9.39101 20.421C9.34012 20.354 9.26244 20.1973 9.15798 19.9509C9.05351 19.7045 8.98253 19.4339 8.94503 19.1393C8.90218 18.7964 8.86869 18.4308 8.84459 18.0424C8.82048 17.654 8.80575 17.35 8.80039 17.1304V15.7161C8.79503 14.9393 8.84325 14.1625 8.94503 13.3857C8.98253 13.0911 9.0495 12.8246 9.14593 12.5862C9.24235 12.3478 9.32807 12.183 9.40307 12.092L9.51557 11.9554C9.59057 11.875 9.66825 11.804 9.7486 11.7424C9.82896 11.6808 9.912 11.6286 9.99771 11.5857C10.0834 11.5429 10.1584 11.508 10.2227 11.4812C10.287 11.4545 10.3633 11.433 10.4517 11.417C10.5401 11.4009 10.6031 11.3888 10.6406 11.3808C10.6781 11.3728 10.7397 11.3647 10.8254 11.3567C10.9111 11.3487 10.9566 11.3446 10.962 11.3446C12.3066 11.2482 13.9861 11.2 16.0004 11.2C16.9004 11.2 17.7696 11.2121 18.608 11.2362C19.4464 11.2603 20.0611 11.2857 20.4522 11.3125L21.0388 11.3446C21.0441 11.3446 21.0897 11.3487 21.1754 11.3567C21.2611 11.3647 21.3227 11.3728 21.3602 11.3808C21.3977 11.3888 21.4607 11.4009 21.549 11.417C21.6374 11.433 21.7138 11.4545 21.7781 11.4812C21.8424 11.508 21.9174 11.5429 22.0031 11.5857C22.0888 11.6286 22.1718 11.6808 22.2522 11.7424C22.3325 11.804 22.4102 11.875 22.4852 11.9554C22.5174 11.9875 22.5589 12.0371 22.6098 12.104C22.6607 12.171 22.7383 12.3277 22.8428 12.5741C22.9473 12.8205 23.0182 13.0911 23.0557 13.3857C23.0986 13.7286 23.1321 14.0942 23.1562 14.4826C23.1803 14.871 23.195 15.175 23.2004 15.3946V16.8089C23.2057 17.5857 23.1575 18.3625 23.0557 19.1393C23.0182 19.4339 22.9513 19.7004 22.8549 19.9388C22.7584 20.1772 22.6727 20.342 22.5977 20.433L22.4852 20.5696C22.4102 20.65 22.3325 20.721 22.2522 20.7826C22.1718 20.8442 22.0888 20.8951 22.0031 20.9353C21.9174 20.9754 21.8424 21.0089 21.7781 21.0357C21.7138 21.0625 21.6374 21.0839 21.549 21.1C21.4607 21.1161 21.3964 21.1281 21.3562 21.1362C21.316 21.1442 21.2544 21.1522 21.1714 21.1603C21.0883 21.1683 21.0441 21.1723 21.0388 21.1723ZM14.5138 14.0848V18.1268L18.4031 16.1179L14.5138 14.0848Z"
        fill="white"
      />
      <defs>
        <linearGradient id="paint0_linear_551_13007" x1="-16" y1="16" x2="16" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF0000" />
          <stop offset="1" stopColor="#F58282" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const IconInstagram = ({ width, height, fill }) => {
  return (
    <svg width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="16" fill="url(#paint0_linear_551_13006)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2916 22.9998C17.5269 22.9978 18.3928 22.9826 18.8893 22.9544C20.1532 22.8937 21.1315 22.5169 21.8242 21.8242C22.5169 21.1315 22.8937 20.1532 22.9544 18.8893C22.9848 18.3546 23 17.3915 23 16L22.9998 15.7084C22.9978 14.4731 22.9826 13.6072 22.9544 13.1107C22.8937 11.8468 22.5169 10.8685 21.8242 10.1758C21.1315 9.48307 20.1532 9.10634 18.8893 9.04557C18.3546 9.01519 17.3915 9 16 9L15.7084 9.00023C14.4731 9.00225 13.6072 9.01736 13.1107 9.04557C11.8468 9.10634 10.8685 9.48307 10.1758 10.1758C9.48307 10.8685 9.10634 11.8468 9.04557 13.1107C9.01519 13.6454 9 14.6085 9 16L9.00023 16.2916C9.00225 17.5269 9.01736 18.3928 9.04557 18.8893C9.10634 20.1532 9.48307 21.1315 10.1758 21.8242C10.8685 22.5169 11.8468 22.8937 13.1107 22.9544C13.6454 22.9848 14.6085 23 16 23L16.2916 22.9998ZM17.6587 21.7467C17.44 21.7498 17.1195 21.7498 16.6972 21.7467C16.3687 21.7444 16.1551 21.7429 16.0564 21.7424H15.9434C15.8447 21.7429 15.6311 21.7444 15.3026 21.7467C14.8803 21.7498 14.5598 21.7498 14.341 21.7467C14.1223 21.7437 13.8291 21.7346 13.4615 21.7194C13.0939 21.7042 12.7809 21.6738 12.5227 21.6283C12.2644 21.5827 12.0472 21.5265 11.871 21.4596C11.5672 21.3381 11.2998 21.1619 11.0689 20.931C10.838 20.7001 10.6618 20.4327 10.5403 20.1289C10.4734 19.9527 10.4172 19.7355 10.3716 19.4772C10.3261 19.219 10.2957 18.906 10.2805 18.5384C10.2653 18.1708 10.2562 17.8776 10.2531 17.6589C10.2521 17.5859 10.2515 17.5017 10.2511 17.4062V17.0856C10.2515 16.9675 10.2521 16.838 10.2531 16.6973L10.2568 16.1692L10.2575 16.0565L10.2577 16L10.2576 15.9788L10.2575 15.9435L10.2568 15.8308L10.2531 15.3027C10.2521 15.162 10.2515 15.0325 10.2511 14.9144V14.5938C10.2515 14.4983 10.2521 14.4141 10.2531 14.3411C10.2562 14.1224 10.2653 13.8292 10.2805 13.4616C10.2957 13.094 10.3261 12.781 10.3716 12.5228C10.4172 12.2645 10.4734 12.0473 10.5403 11.8711C10.6618 11.5673 10.838 11.2999 11.0689 11.069C11.2998 10.8381 11.5672 10.6619 11.871 10.5404C12.0472 10.4735 12.2644 10.4173 12.5227 10.3717C12.7809 10.3262 13.0939 10.2958 13.4615 10.2806C13.8291 10.2654 14.1223 10.2563 14.341 10.2533C14.5598 10.2502 14.8803 10.2502 15.3026 10.2533C15.6311 10.2556 15.8447 10.2571 15.9434 10.2576L16.6926 10.2578C17.1179 10.2517 17.44 10.2502 17.6587 10.2533C17.8775 10.2563 18.1707 10.2654 18.5383 10.2806C18.9059 10.2958 19.2189 10.3262 19.4771 10.3717C19.7353 10.4173 19.9526 10.4735 20.1288 10.5404C20.4326 10.6619 20.7 10.8381 20.9309 11.069C21.1618 11.2999 21.338 11.5673 21.4595 11.8711C21.5264 12.0473 21.5826 12.2645 21.6281 12.5228C21.6737 12.781 21.7041 13.094 21.7193 13.4616C21.7345 13.8292 21.7436 14.1224 21.7466 14.3411C21.7476 14.4141 21.7483 14.4983 21.7487 14.5938V14.9144C21.7483 15.0325 21.7476 15.162 21.7466 15.3027L21.7426 15.8942V16.1058L21.7466 16.6973C21.7476 16.838 21.7483 16.9675 21.7487 17.0856V17.4062C21.7483 17.5017 21.7476 17.5859 21.7466 17.6589C21.7436 17.8776 21.7345 18.1708 21.7193 18.5384C21.7041 18.906 21.6737 19.219 21.6281 19.4772C21.5826 19.7355 21.5264 19.9527 21.4595 20.1289C21.338 20.4327 21.1618 20.7001 20.9309 20.931C20.7 21.1619 20.4326 21.3381 20.1288 21.4596C19.9526 21.5265 19.7353 21.5827 19.4771 21.6283C19.2189 21.6738 18.9059 21.7042 18.5383 21.7194C18.1707 21.7346 17.8775 21.7437 17.6587 21.7467ZM20.3293 12.8555C20.1653 13.0195 19.9678 13.1016 19.7369 13.1016C19.506 13.1016 19.3085 13.0195 19.1444 12.8555C18.9804 12.6914 18.8983 12.4939 18.8983 12.263C18.8983 12.0321 18.9804 11.8346 19.1444 11.6706C19.3085 11.5065 19.506 11.4245 19.7369 11.4245C19.9678 11.4245 20.1653 11.5065 20.3293 11.6706C20.4934 11.8346 20.5754 12.0321 20.5754 12.263C20.5754 12.4939 20.4934 12.6914 20.3293 12.8555ZM16.0001 19.5912C16.9966 19.5912 17.8443 19.2418 18.5431 18.543C19.2418 17.8442 19.5912 16.9965 19.5912 16C19.5912 15.0035 19.2418 14.1558 18.5431 13.457C17.8443 12.7583 16.9966 12.4089 16.0001 12.4089C15.0036 12.4089 14.1559 12.7583 13.4571 13.457C12.7583 14.1558 12.4089 15.0035 12.4089 16C12.4089 16.9965 12.7583 17.8442 13.4571 18.543C14.1559 19.2418 15.0036 19.5912 16.0001 19.5912ZM14.3503 17.6497C14.806 18.1055 15.3559 18.3333 16 18.3333C16.6441 18.3333 17.1941 18.1055 17.6498 17.6497C18.1055 17.194 18.3334 16.6441 18.3334 16C18.3334 15.3559 18.1055 14.806 17.6498 14.3503C17.1941 13.8945 16.6441 13.6667 16 13.6667C15.3559 13.6667 14.806 13.8945 14.3503 14.3503C13.8946 14.806 13.6667 15.3559 13.6667 16C13.6667 16.6441 13.8946 17.194 14.3503 17.6497Z"
        fill="white"
      />
      <defs>
        <linearGradient id="paint0_linear_551_13006" x1="-13.8564" y1="8" x2="8" y2="45.8564" gradientUnits="userSpaceOnUse">
          <stop offset="0.039" stopColor="#8549E4" />
          <stop offset="0.1637" stopColor="#A847BF" />
          <stop offset="0.3202" stopColor="#CD4498" />
          <stop offset="0.464" stopColor="#E9427B" />
          <stop offset="0.5889" stopColor="#F9416A" />
          <stop offset="0.6809" stopColor="#FF4164" />
          <stop offset="0.7377" stopColor="#FF525D" />
          <stop offset="0.85" stopColor="#FF7E4B" />
          <stop offset="1" stopColor="#FFC12F" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const IconGooglePlus = ({ width, height, fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="16" fill="#DC4E41" />
      <path
        fill="#fff"
        d="M12.446 15.668v1.867h3.088c-.124.801-.933 2.35-3.088 2.35-1.86 0-3.377-1.541-3.377-3.44 0-1.898 1.517-3.438 3.377-3.438 1.058 0 1.766.451 2.17.84l1.478-1.423C15.145 11.537 13.916 11 12.446 11A5.442 5.442 0 0 0 7 16.446a5.442 5.442 0 0 0 5.446 5.445c3.143 0 5.227-2.21 5.227-5.32 0-.359-.038-.631-.085-.903h-5.142Z"
      />
      <path
        fill="#fff"
        d="M12.446 15.761h5.142c.054.257.085.529.085.856v-.055c0-.358-.038-.63-.085-.902h-5.142v.101Zm0-4.668c1.439 0 2.652.522 3.586 1.377l.054-.054c-.94-.88-2.17-1.416-3.64-1.416A5.442 5.442 0 0 0 7 16.446v.046c.031-2.98 2.458-5.399 5.446-5.399Zm0 8.884c2.155 0 2.964-1.54 3.088-2.349h-.023c-.171.825-.988 2.248-3.065 2.248-1.844 0-3.346-1.517-3.369-3.384 0 .016-.008.031-.008.047 0 1.898 1.517 3.438 3.377 3.438Z"
        opacity=".4"
      />
      <path
        fill="#3E2723"
        d="M12.446 13.007c-1.86 0-3.377 1.54-3.377 3.439 0 .015.008.03.008.046.023-1.875 1.525-3.384 3.369-3.384 1.058 0 1.766.451 2.17.84l1.478-1.423c-.015-.016-.039-.031-.054-.047l-1.424 1.377c-.404-.389-1.112-.848-2.17-.848Zm0 4.528v.093h3.065c.008-.031.015-.07.023-.093h-3.088Z"
        opacity=".1"
      />
      <path
        fill="#3E2723"
        d="M12.446 21.891A5.452 5.452 0 0 1 7 16.492v.047a5.442 5.442 0 0 0 5.446 5.446c3.143 0 5.227-2.21 5.227-5.322v-.046c-.023 3.088-2.1 5.274-5.227 5.274Z"
        opacity=".1"
      />
      <path fill="#fff" d="M24.115 15.668h-1.556v-1.556h-1.556v1.556h-1.556v1.556h1.556v1.555h1.556v-1.555h1.556" />
      <path fill="#fff" d="M22.56 15.668h1.555v.093h-1.556v-.093Zm-1.557-1.556h1.556v.093h-1.556v-.093Zm-1.556 1.556h1.556v.093h-1.556v-.093Z" opacity=".4" />
      <path fill="#3E2723" d="M19.447 17.224h1.556v.093h-1.556v-.093Zm3.112 0h1.556v.093h-1.556v-.093Zm-1.556 1.555h1.556v.094h-1.556v-.094Z" opacity=".1" />
    </svg>
  );
};

export const IconQq = ({ width, height, fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="16" fill="#fff" />
      <g clip-path="url(#a)">
        <path
          fill="#FAAB07"
          d="M16 23.504c-1.405 0-2.694-.451-3.525-1.126-.422.121-.961.316-1.301.557-.292.207-.255.418-.203.502.23.374 3.954.239 5.03.123v-.056Zm0 0c1.406 0 2.695-.451 3.526-1.126.421.121.96.316 1.301.557.292.207.255.418.203.502-.23.374-3.954.239-5.03.123v-.056Z"
        />
        <path
          fill="#000"
          d="M16.009 15.416c2.32-.015 4.18-.447 4.81-.612.15-.04.23-.11.23-.11 0-.02.01-.363.01-.54 0-2.975-1.462-5.965-5.059-5.965-3.596 0-5.059 2.99-5.059 5.965 0 .177.01.52.01.54 0 0 .065.066.185.098.582.155 2.476.608 4.856.624h.017Zm6.305 2.479a24.43 24.43 0 0 0-.539-1.461s-.114-.014-.172.002c-1.784.498-3.947.815-5.594.796h-.018c-1.638.019-3.786-.294-5.564-.787-.068-.02-.202-.011-.202-.011a24.346 24.346 0 0 0-.539 1.46c-.686 2.12-.464 2.998-.294 3.018.363.042 1.413-1.596 1.413-1.596 0 1.665 1.565 4.22 5.148 4.244h.095c3.583-.024 5.147-2.58 5.147-4.244 0 0 1.05 1.638 1.414 1.596.169-.02.391-.897-.295-3.017Z"
        />
        <path
          fill="#fff"
          d="M14.72 12.585c-.488.02-.904-.513-.93-1.192-.027-.678.347-1.246.835-1.267.487-.021.904.512.93 1.191.027.68-.347 1.247-.835 1.268Zm3.49-1.192c-.026.68-.442 1.213-.93 1.192-.488-.021-.862-.589-.835-1.268.026-.678.443-1.212.93-1.191.488.021.862.589.836 1.268Z"
        />
        <path
          fill="#FAAB07"
          d="M19.078 13.543c-.13-.277-1.444-.586-3.07-.586h-.017c-1.625 0-2.938.309-3.069.586a.09.09 0 0 0-.01.04c0 .02.008.038.019.053.11.154 1.568.914 3.06.914h.018c1.492 0 2.95-.76 3.06-.914a.091.091 0 0 0 .018-.053.09.09 0 0 0-.01-.04"
        />
        <path
          fill="#000"
          d="M15.32 11.403c.022.269-.13.507-.341.533-.212.026-.4-.17-.423-.438-.022-.269.13-.507.341-.533.212-.026.4.17.423.438Zm1.34.09c.043-.074.337-.464.945-.322.16.037.234.092.25.114.022.031.029.077.005.138-.046.121-.141.118-.194.094-.034-.015-.458-.286-.848.118-.027.028-.075.038-.12.005-.046-.033-.065-.1-.038-.147Z"
        />
        <path
          fill="#fff"
          d="M16.009 17.135h-.018c-1.12.012-2.48-.13-3.795-.38a9.852 9.852 0 0 0-.122 2.354c.147 2.373 1.615 3.865 3.88 3.887h.092c2.266-.022 3.733-1.514 3.881-3.887a9.84 9.84 0 0 0-.122-2.353c-1.316.249-2.675.392-3.796.378"
        />
        <path fill="#EB1923" d="M12.816 16.936v2.336s1.114.216 2.23.066v-2.154a21.31 21.31 0 0 1-2.23-.248Z" />
        <path
          fill="#EB1923"
          d="M21.05 14.694s-2.168.657-5.041.675h-.018c-2.868-.018-5.033-.673-5.04-.675l-.726 1.74c1.816.525 4.065.864 5.767.844h.017c1.7.02 3.95-.319 5.766-.844l-.726-1.74Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M9 8h14v16H9z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Iconweibo = ({ width, height, fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="16" fill="url(#a)" />
      <g fill="#fff" clip-path="url(#b)">
        <path d="M22.987 13.766c.06.768-.072 1.687-.587 1.732-.841.074-.403-.837-.392-1.385.031-1.59-1.348-2.694-2.7-2.694-.383 0-1.272.256-1.135-.539.062-.35.363-.345.665-.385 2.273-.297 3.989 1.24 4.149 3.271ZM19.269 15.613c.977.526 2.15.788 1.956 2.348-.358 2.875-6.448 4.806-10.252 2.693-1.043-.58-2.122-1.428-1.956-3.117.143-1.454 1.137-2.58 2.113-3.54.931-.916 1.912-1.632 3.248-1.963 1.449-.358 1.877.83 1.486 2.001.84-.055 2.619-.976 3.405-.077.346.397.214 1.107 0 1.655Zm-1.056 3.695c.313-.35.627-.881.625-1.5-.006-2.565-4.453-3.137-6.887-1.733-2.769 1.599-1.6 4.47 1.8 4.695 1.802.119 3.605-.506 4.461-1.462Z" />
        <path d="M20.639 14.882c-.57.038-.357-.383-.392-.885-.021-.308-.282-.665-.508-.77-.445-.205-1.135.15-1.135-.461 0-.454.4-.407.627-.424 2.073-.155 2.202 2.488 1.408 2.54ZM16.491 17.615c.834 2.478-3.51 3.63-4.304 1.5-.532-1.423.745-2.556 2.073-2.693 1.135-.117 1.98.452 2.231 1.193Zm-1.996.423c.177.301.583.085.548-.154-.043-.276-.552-.235-.548.154Zm-.704 1.309c.73-.171.828-1.524-.274-1.27-.926.212-.747 1.508.274 1.27Z" />
      </g>
      <defs>
        <linearGradient id="a" x1="0" x2="32" y1="0" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E6162D" />
          <stop offset="1" stopColor="#F93" />
        </linearGradient>
        <clipPath id="b">
          <path fill="#fff" d="M9 9h14v14H9z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconTwitter = ({ width, height, fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="16" fill="#fff" />
      <path
        fill="#000"
        d="M17.332 14.928 22.544 9h-1.235l-4.526 5.147L13.17 9H9l5.466 7.784L9 23h1.235l4.78-5.436L18.83 23H23l-5.668-8.072Zm-1.692 1.924-.554-.775L10.68 9.91h1.897l3.556 4.977.554.775 4.622 6.47h-1.897l-3.772-5.28Z"
      />
    </svg>
  );
};

export const Iconwebsite = ({ width, height, fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || 20} height={height || 20} viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" fill="none" stroke={fill || 'white'} />
      <ellipse cx="12" cy="12" rx="3.5" ry="10" fill="none" stroke={fill || 'white'} />
      <path fill="none" stroke={fill || 'white'} d="M2 12h20" />
    </svg>
  );
};

export const IconlinkedIn = ({ width, height, fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="16" fill="#0A66C2" />
      <path
        fill="#F1F2F2"
        d="M24 17.583V23h-3.216v-5.054c0-1.27-.464-2.136-1.628-2.136-.889 0-1.417.583-1.65 1.149-.084.201-.106.482-.106.765V23h-3.216s.043-8.56 0-9.447H17.4v1.34c-.006.01-.016.02-.021.03h.021v-.03c.427-.643 1.19-1.561 2.898-1.561 2.116 0 3.702 1.35 3.702 4.25ZM10.82 9C9.72 9 9 9.705 9 10.632c0 .907.699 1.633 1.777 1.633h.021c1.122 0 1.82-.726 1.82-1.633C12.595 9.705 11.92 9 10.82 9ZM9.19 23h3.215v-9.447H9.19V23Z"
      />
    </svg>
  );
};

export const IconArrowBack = ({ width, height }) => {
  return (
    <svg width={width || 20} height={height || 20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 16.6L7.06667 11.1667C6.425 10.525 6.425 9.47499 7.06667 8.83333L12.5 3.39999"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconShare = ({ width, height, fill }) => {
  return (
    <svg width={width || 20} height={height || 20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.16689 5.26667L13.2419 2.90834C16.4169 1.85001 18.1419 3.58334 17.0919 6.75834L14.7336 13.8333C13.1502 18.5917 10.5502 18.5917 8.96689 13.8333L8.26689 11.7333L6.16689 11.0333C1.40856 9.45001 1.40856 6.85834 6.16689 5.26667Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.4248 11.375L11.4081 8.3833" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const IconArrowDown = ({ width, height, fill }) => {
  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
        stroke={fill || '#E5E5E5'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconArrowUpPlayer = ({ width, height, fill }) => {
  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.07998 15.05L10.6 8.53C11.37 7.76 12.63 7.76 13.4 8.53L19.92 15.05"
        stroke={fill || 'white'}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconDownload = ({ width, height, fill }) => {
  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.44 8.89999C20.04 9.20999 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.23999 7.46998 8.90999"
        stroke="#E5E5E5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 2V14.88" stroke="#E5E5E5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.3499 12.65L11.9999 16L8.6499 12.65" stroke="#E5E5E5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const IconMinus = ({ width, height, fill }) => {
  return (
    <svg width={width || 12} height={height || 4} viewBox="0 0 12 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.01803 3.01864L12 3.01818V0.981812L7.01803 0.982587H4.98112L0 0.981812V3.01818L4.98112 3.01864H7.01803Z" fill={fill || 'white'} />
    </svg>
  );
};

export const IconPlus = ({ width, height, fill }) => {
  return (
    <svg width={width || 12} height={height || 12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.01818 12L7.01803 7.01865L12 7.01818V4.98182L7.01803 4.98259L7.01818 0H4.98182L4.98112 4.98259L0 4.98182V7.01818L4.98112 7.01865L4.98182 12H7.01818Z"
        fill={fill || 'white'}
      />
    </svg>
  );
};

export const IconArrowUp = ({ width, height, fill, className }) => {
  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.9201 15.05L13.4001 8.53005C12.6301 7.76005 11.3701 7.76005 10.6001 8.53005L4.08008 15.05"
        stroke="#E5E5E5"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconArrowRight = ({ width, height, fill }) => {
  return (
    <svg width={width || 5} height={height || 8} viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.422846 0.275814C0.636698 0.0625958 0.982894 0.0630715 1.19616 0.276876L4.5235 3.61384C4.73631 3.82728 4.73631 4.17266 4.5235 4.3861L1.19616 7.72319C1.05894 7.86497 0.855994 7.92185 0.665082 7.87202C0.474169 7.82219 0.324898 7.67339 0.274471 7.48264C0.224043 7.29188 0.280279 7.08876 0.421628 6.9511L3.36385 4.00003L0.421628 1.04928C0.319208 0.946559 0.261797 0.807353 0.262025 0.662296C0.262254 0.517238 0.320104 0.378214 0.422846 0.275814Z"
        fill={fill || 'white'}
      />
    </svg>
  );
};

export const IconPlay = ({ width, height, fill }) => {
  return (
    <svg width={width || 25} height={height || 24} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.5 12V8.44002C4.5 4.02002 7.63 2.21002 11.46 4.42002L14.55 6.20002L17.64 7.98002C21.47 10.19 21.47 13.81 17.64 16.02L14.55 17.8L11.46 19.58C7.63 21.79 4.5 19.98 4.5 15.56V12Z"
        stroke="#E5E5E5"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconMusicPlay = ({ width, height, fill }) => {
  return (
    <svg width={width || 28} height={height || 28} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.00024 14V9.995C5.00024 5.0225 8.52149 2.98625 12.8302 5.4725L16.3065 7.475L19.7827 9.4775C24.0915 11.9638 24.0915 16.0363 19.7827 18.5225L16.3065 20.525L12.8302 22.5275C8.52149 25.0138 5.00024 22.9775 5.00024 18.005V14Z"
        fill="white"
      />
    </svg>
  );
};

export const IconVolume = ({ width, height, fill }) => {
  return (
    <svg width={width || 13} height={height || 14} viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.34389 13.7812C8.20279 13.9271 8.03569 14 7.84259 14C7.6495 14 7.4824 13.9271 7.34129 13.7812L3.63165 9.94737H0.712963C0.519869 9.94737 0.352768 9.87445 0.211661 9.72862C0.0705536 9.58279 0 9.41009 0 9.21053V4.78947C0 4.58991 0.0705536 4.41721 0.211661 4.27138C0.352768 4.12555 0.519869 4.05263 0.712963 4.05263H3.63165L7.34129 0.21875C7.4824 0.0729167 7.6495 0 7.84259 0C8.03569 0 8.20279 0.0729167 8.34389 0.21875C8.485 0.364583 8.55556 0.537281 8.55556 0.736842V13.2632C8.55556 13.4627 8.485 13.6354 8.34389 13.7812ZM11.1066 9.70559C11.0324 9.74397 10.9395 9.76316 10.8281 9.76316C10.635 9.76316 10.4679 9.69216 10.3268 9.55017C10.1857 9.40817 10.1152 9.23355 10.1152 9.02632C10.1152 8.86513 10.1597 8.72889 10.2488 8.6176C10.338 8.5063 10.4457 8.41036 10.5719 8.32977C10.6982 8.24918 10.8244 8.16091 10.9507 8.06497C11.0769 7.96902 11.1846 7.83087 11.2737 7.65049C11.3628 7.47012 11.4074 7.25329 11.4074 7C11.4074 6.74671 11.3628 6.52988 11.2737 6.34951C11.1846 6.16913 11.0769 6.03098 10.9507 5.93503C10.8244 5.83909 10.6982 5.75082 10.5719 5.67023C10.4457 5.58964 10.338 5.4937 10.2488 5.3824C10.1597 5.27111 10.1152 5.13487 10.1152 4.97368C10.1152 4.76645 10.1857 4.59183 10.3268 4.44984C10.4679 4.30784 10.635 4.23684 10.8281 4.23684C10.9395 4.23684 11.0324 4.25603 11.1066 4.29441C11.6265 4.50164 12.0424 4.85855 12.3543 5.36513C12.6737 5.87171 12.8333 6.41667 12.8333 7C12.8333 7.58333 12.6755 8.12637 12.3599 8.62911C12.0442 9.13185 11.6265 9.49068 11.1066 9.70559Z"
        fill={fill || 'white'}
      />
    </svg>
  );
};

export const IconSearch = ({ width, height, className, fill }) => {
  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
        stroke="#909096"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M22 22L20 20" stroke="#909096" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const IconShuffle = ({ width, height, className, fill }) => {
  return (
    <svg width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 23.9733L7.39998 23.9866C8.61332 23.9866 9.74666 23.3866 10.4133 22.3866L18.9333 9.61332C19.6 8.61332 20.7333 7.99997 21.9467 8.01331L28.0133 8.04"
        stroke="#E5E5E5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M25.3333 26.64L27.9999 23.9733" stroke="#E5E5E5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11.8534 11.4933L10.4133 9.49332C9.73333 8.54665 8.63998 7.98666 7.47998 7.99999L4 8.01334"
        stroke="#E5E5E5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M17.2935 20.5067L18.9201 22.6C19.6001 23.48 20.6668 24 21.7868 24L28.0135 23.9733" stroke="#E5E5E5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M27.9999 8.02668L25.3333 5.36002" stroke="#E5E5E5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const IconComment = ({ width, height, className, fill }) => {
  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 6.25V11.35C22 12.62 21.58 13.69 20.83 14.43C20.09 15.18 19.02 15.6 17.75 15.6V17.41C17.75 18.09 16.99 18.5 16.43 18.12L15.46 17.48C15.55 17.17 15.59 16.83 15.59 16.47V12.4C15.59 10.36 14.23 9 12.19 9H5.39999C5.25999 9 5.13 9.01002 5 9.02002V6.25C5 3.7 6.7 2 9.25 2H17.75C20.3 2 22 3.7 22 6.25Z"
        stroke="white"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.59 12.4V16.47C15.59 16.83 15.55 17.17 15.46 17.48C15.09 18.95 13.87 19.87 12.19 19.87H9.47L6.45 21.88C6 22.19 5.39999 21.86 5.39999 21.32V19.87C4.37999 19.87 3.53 19.53 2.94 18.94C2.34 18.34 2 17.49 2 16.47V12.4C2 10.5 3.18 9.19002 5 9.02002C5.13 9.01002 5.25999 9 5.39999 9H12.19C14.23 9 15.59 10.36 15.59 12.4Z"
        stroke="white"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const IconRefresh = ({ width, height, className, fill }) => {
  return (
    <svg width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.4001 28.8933C25.1201 27.3867 29.3334 22.1867 29.3334 16C29.3334 8.63999 23.4134 2.66666 16.0001 2.66666C7.10675 2.66666 2.66675 10.08 2.66675 10.08M2.66675 10.08V3.99999M2.66675 10.08H5.34675H8.58675"
        stroke="#E5E5E5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2.66675 16C2.66675 23.36 8.64008 29.3333 16.0001 29.3333" stroke="#E5E5E5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="3 3" />
    </svg>
  );
};

export const IconPrev = ({ width, height, className, fill }) => {
  return (
    <svg width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.9869 9.62666V22.3867C26.9869 25 24.1469 26.64 21.8802 25.3333L16.3469 22.1466L10.8135 18.9467C8.54686 17.64 8.54686 14.3733 10.8135 13.0666L16.3469 9.86665L21.8802 6.68001C24.1469 5.37334 26.9869 7 26.9869 9.62666Z"
        stroke="#E5E5E5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5.01343 24.24V7.76001" stroke="#E5E5E5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const IconNext = ({ width, height, className, fill }) => {
  return (
    <svg width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.01343 9.62666V22.3867C5.01343 25 7.85341 26.64 10.1201 25.3333L15.6534 22.1466L21.1868 18.9467C23.4534 17.64 23.4534 14.3733 21.1868 13.0666L15.6534 9.86665L10.1201 6.68001C7.85341 5.37334 5.01343 7 5.01343 9.62666Z"
        stroke="#E5E5E5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M26.9868 24.24V7.76001" stroke="#E5E5E5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const IconPause = ({ width, height, className, fill }) => {
  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.65 19.11V4.89C10.65 3.54 10.08 3 8.64 3H5.01C3.57 3 3 3.54 3 4.89V19.11C3 20.46 3.57 21 5.01 21H8.64C10.08 21 10.65 20.46 10.65 19.11Z" fill={fill || 'white'} />
      <path
        d="M21 19.11V4.89C21 3.54 20.43 3 18.99 3H15.36C13.93 3 13.35 3.54 13.35 4.89V19.11C13.35 20.46 13.92 21 15.36 21H18.99C20.43 21 21 20.46 21 19.11Z"
        fill={fill || 'white'}
      />
    </svg>
  );
};

export const IconBounce = ({ fill }) => {
  return (
    <svg className="bounce" id=" Layer_1" fill="#004eff" xmlns=" http://www.w3.org/2000/svg" x="0px" y="0px" width="45" height="75" viewBox="0 0 54.5 107">
      <path
        // fill={fill || 'white'}
        // attributeName="fill"
        className="color"
        d="M37.784 1.807l-4.97 20.655a.451.451 0 0 0 .545.544l5.64-1.376a.446.446 0 0 1 .552.362c.873 5.694 8.017 60.747-38.02 83.164-.494.24-.229.988.301.846 12.441-3.339 49.228-18.994 45.496-86.952a.451.451 0 0 1 .333-.462l5.229-1.376a.451.451 0 0 0 .208-.752L38.545 1.597a.45.45 0 0 0-.761.21z"
      >
        {/* <animate attributeName="fill" begin="1s" dur="1.5s" values="white; black" repeatCount="indefinite" /> */}
      </path>
    </svg>
  );
};

export const IconiOSInstall = ({ fill }) => {
  return (
    <svg className="svg-icon" width="16" height="16" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={fill || 'white'}
        d="M896 320v576c0 35.392-28.608 64-64 64H256c-35.392 0-64-28.608-64-64V320h163.328c72.832 0 72.832 64 0 64H256v512h576V384h-94.976c-72.832 0-72.832-64 0-64H896zM694.4 206.656 564.544 73.6c-.128-.128-.32-.192-.512-.256-2.816-2.88-9.536-5.248-13.312-6.848-3.392-1.344-.576-1.856-4.096-2.112-.768 0-1.344-.384-2.048-.384-.512 0-.896.256-1.408.256-3.84.192-5.76.896-9.344 2.24-3.264 1.408-6.016 3.52-8.64 5.76-.64.512-1.472.768-2.048 1.344L390.208 206.656c-12.864 12.8-6.976 33.6 5.888 46.4 12.8 12.864 33.6 12.864 46.464 0l70.976-76.864.064 429.696c0 18.752 12.8 33.984 30.912 33.92 18.112.064 29.696-15.168 29.696-33.984V176.128l79.552 76.864c12.864 12.864 33.6 12.864 46.528 0 6.4-6.4 3.776-14.72 3.776-23.168s-3.328-16.832-9.664-23.168z"
      />
    </svg>
  );
};

export const IconiOSPlus = ({ fill }) => {
  return (
    <svg id="Layer_radius" className="rounded" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="13" height="13" viewBox="0 0 330 330">
      <path
        fill={fill || 'white'}
        id=" XMLID_23_"
        d="M315 0H15C6.716 0 0 6.716 0 15v300c0 8.284 6.716 15 15 15h300c8.284 0 15-6.716 15-15V15c0-8.284-6.716-15-15-15zm-60 180h-75v75c0 8.284-6.716 15-15 15s-15-6.716-15-15v-75H75c-8.284 0-15-6.716-15-15s6.716-15 15-15h75V75c0-8.284 6.716-15 15-15s15 6.716 15 15v75h75c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
      ></path>
    </svg>
  );
};

export const IconCross = ({ width, height, fill }) => {
  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
        stroke={fill || 'white'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.16992 14.83L14.8299 9.17004" stroke={fill || 'white'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.8299 14.83L9.16992 9.17004" stroke={fill || 'white'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const IconClear = ({ width, height, fill }) => {
  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 19L19 5" stroke="#909096" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19 19L5 5" stroke="#909096" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const IconClearBold = ({ width, height, fill }) => {
  return (
    <svg width={width || 10} height={height || 10} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.08325 7.91667L7.91659 2.08333" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.91659 7.91667L2.08325 2.08333" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const IconAndroidDots = ({ fill }) => {
  return (
    <svg id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" width="14" height="14">
      <circle fill={fill || 'white'} cx="256" cy="256" r="64"></circle>
      <circle fill={fill || 'white'} cx="256" cy="448" r="64"></circle>
      <circle fill={fill || 'white'} cx="256" cy="64" r="64"></circle>
    </svg>
  );
};

export const IconNoComment = ({ fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24">
      <path fill="none" stroke={fill || 'white'} strokeMiterlimit="10" d="m1 1 21 21" />
      <path d="M7.5 4H22v13h-1.5M17 17h-4l-5 4v-4H4V4" fill="none" stroke={fill || 'white'} />
    </svg>
  );
};
export const IconLike = ({ width, height, fill }) => {
  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.65945 21.7777C8.57343 21.1334 7.7978 19.9999 7.75343 18.6667C7.68696 16.1779 9.41566 14.9556 10.4352 13.2889C11.898 10.889 11.499 9.40006 11.499 9.40006C11.499 9.40006 12.718 10.0889 13.4272 12.6446C13.6489 13.4001 13.6931 14.1556 13.6266 14.8668C13.5158 16.6668 12.7402 18.2889 12.7402 18.2889C12.7402 18.2889 14.0921 18 14.4689 15.5333C15.0894 16.1777 15.6656 17.1112 15.7322 18.0888C15.8431 19.7778 14.8456 21.3333 13.3386 22C15.9538 21.4 17.8156 19.1777 18.4583 17.5556C19.2783 15.5111 19.0567 13.6889 18.9238 12.1111C18.7465 9.95558 19.5 8.35554 19.5 8.35554C19.5 8.35554 18.0595 8.7778 16.9955 10.5333C16.508 11.3333 16.3085 12.5111 16.3085 12.5111C16.3085 12.5111 16.4194 11.4666 15.7323 9.5555C15.0453 7.68888 14.4247 7.02217 14.048 5.64444C13.5604 3.8 14.6463 2 14.6463 2C14.6463 2 10.3466 2.8 8.39629 6.55555C6.66757 9.88887 7.37671 11.8889 7.37671 11.8889C7.37671 11.8889 6.64533 11.2 6.26856 10.2444C5.8918 9.28891 5.98039 8.42209 5.98039 8.42209C5.98039 8.42209 2.92185 11.7999 4.40673 16.0443C5.40419 19.0223 7.33233 20.9776 9.65937 21.7776L9.65945 21.7777Z"
        fill={fill || 'white'}
      />
    </svg>
  );
};
export const IconLikeActive = ({ fill }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.65945 21.7777C8.57343 21.1334 7.7978 19.9999 7.75343 18.6667C7.68696 16.1779 9.41566 14.9556 10.4352 13.2889C11.898 10.889 11.499 9.40006 11.499 9.40006C11.499 9.40006 12.718 10.0889 13.4272 12.6446C13.6489 13.4001 13.6931 14.1556 13.6266 14.8668C13.5158 16.6668 12.7402 18.2889 12.7402 18.2889C12.7402 18.2889 14.0921 18 14.4689 15.5333C15.0894 16.1777 15.6656 17.1112 15.7322 18.0888C15.8431 19.7778 14.8456 21.3333 13.3386 22C15.9538 21.4 17.8156 19.1777 18.4583 17.5556C19.2783 15.5111 19.0567 13.6889 18.9238 12.1111C18.7465 9.95558 19.5 8.35554 19.5 8.35554C19.5 8.35554 18.0595 8.7778 16.9955 10.5333C16.508 11.3333 16.3085 12.5111 16.3085 12.5111C16.3085 12.5111 16.4194 11.4666 15.7323 9.5555C15.0453 7.68888 14.4247 7.02217 14.048 5.64444C13.5604 3.8 14.6463 2 14.6463 2C14.6463 2 10.3466 2.8 8.39629 6.55555C6.66757 9.88887 7.37671 11.8889 7.37671 11.8889C7.37671 11.8889 6.64533 11.2 6.26856 10.2444C5.8918 9.28891 5.98039 8.42209 5.98039 8.42209C5.98039 8.42209 2.92185 11.7999 4.40673 16.0443C5.40419 19.0223 7.33233 20.9776 9.65937 21.7776L9.65945 21.7777Z"
        fill="url(#paint0_linear_6062_17806)"
      />
      <defs>
        <linearGradient id="paint0_linear_6062_17806" x1="11.75" y1="2" x2="11.75" y2="22" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EBFF00" />
          <stop offset="0.588542" stopColor="#FF6B00" />
          <stop offset="1" stopColor="#FF3D00" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const IconLikeOld = ({ fill }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.44 3.10001C14.63 3.10001 13.01 3.98001 12 5.33001C10.99 3.98001 9.37 3.10001 7.56 3.10001C4.49 3.10001 2 5.60001 2 8.69001C2 9.88001 2.19 10.98 2.52 12C4.1 17 8.97 19.99 11.38 20.81C11.72 20.93 12.28 20.93 12.62 20.81C15.03 19.99 19.9 17 21.48 12C21.81 10.98 22 9.88001 22 8.69001C22 5.60001 19.51 3.10001 16.44 3.10001Z"
        fill={fill || 'white'}
      />
    </svg>
  );
};

export const IconInfo = ({ fill }) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.268 0.599976C5.49952 0.599976 3.80352 1.30249 2.55304 2.55302C1.30252 3.80345 0.6 5.49954 0.6 7.26798C0.6 9.03641 1.30252 10.7325 2.55304 11.9829C3.80347 13.2335 5.49956 13.936 7.268 13.936C9.03644 13.936 10.7325 13.2335 11.983 11.9829C13.2335 10.7325 13.936 9.03641 13.936 7.26798C13.936 5.49954 13.2335 3.8035 11.983 2.55302C10.7325 1.30249 9.03644 0.599976 7.268 0.599976ZM7.1813 11.5728C7.064 11.5728 6.95153 11.5261 6.86874 11.443C6.78595 11.36 6.73953 11.2473 6.7399 11.13C6.74027 11.0127 6.78735 10.9003 6.8706 10.8178C6.95395 10.7352 7.0667 10.6893 7.184 10.6899C7.3013 10.6907 7.41348 10.738 7.49582 10.8215C7.57814 10.9052 7.62382 11.018 7.6227 11.1353C7.62131 11.2516 7.57423 11.3627 7.49163 11.4445C7.40903 11.5264 7.29758 11.5724 7.18131 11.5728L7.1813 11.5728ZM8.2015 7.08932C7.604 7.44272 7.6267 7.8628 7.6267 7.88952V8.95642V8.95633C7.6267 9.06247 7.58456 9.16424 7.50958 9.23931C7.43451 9.31429 7.33274 9.35643 7.22669 9.35643C7.1185 9.35754 7.01413 9.31633 6.9359 9.24164C6.85766 9.16685 6.81171 9.06452 6.8079 8.95634V7.95215C6.7852 7.59875 6.9639 6.91326 7.75608 6.42917C8.15618 6.18648 8.61627 5.76237 8.61627 5.14887V5.14896C8.61627 4.65937 8.35505 4.20709 7.93114 3.96226C7.50713 3.71752 6.98481 3.71752 6.5608 3.96226C6.13689 4.20709 5.87567 4.65937 5.87567 5.14896C5.85883 5.27855 5.77976 5.39175 5.66385 5.45221C5.54795 5.51259 5.4099 5.51259 5.294 5.45221C5.17809 5.39175 5.09902 5.27854 5.08218 5.14896C5.0779 4.36758 5.49083 3.64327 6.16534 3.24886C6.83986 2.85452 7.67364 2.84988 8.35243 3.23686C9.03133 3.62384 9.45207 4.34357 9.45634 5.12496C9.45503 5.89716 9.01363 6.60125 8.20145 7.08934L8.2015 7.08932Z"
        fill={fill || 'white'}
      />
    </svg>
  );
};

export const IconSend = ({ fill }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.4501 2.4667L5.9251 4.9667C0.866765 6.65837 0.866765 9.4167 5.9251 11.1L8.15843 11.8417L8.9001 14.075C10.5834 19.1334 13.3501 19.1334 15.0334 14.075L17.5418 6.55837C18.6584 3.18337 16.8251 1.3417 13.4501 2.4667ZM13.7168 6.95004L10.5501 10.1334C10.4251 10.2584 10.2668 10.3167 10.1084 10.3167C9.9501 10.3167 9.79176 10.2584 9.66676 10.1334C9.4251 9.8917 9.4251 9.4917 9.66676 9.25004L12.8334 6.0667C13.0751 5.82504 13.4751 5.82504 13.7168 6.0667C13.9584 6.30837 13.9584 6.70837 13.7168 6.95004Z"
        fill="white"
      />
    </svg>
  );
};

export const IconArrowDownFill = ({ fill }) => {
  return (
    <svg width="29" height="17" viewBox="0 0 29 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_5718_19871)">
        <path d="M14.3333 9L24.1483 0H4.51838L14.3333 9Z" fill={fill || '#61719C'} />
      </g>
      <defs>
        <filter id="filter0_d_5718_19871" x="0.518555" y="0" width="27.6299" height="17" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5718_19871" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_5718_19871" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export const IconHelp = ({ fill }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 18.4301H13L8.54999 21.39C7.88999 21.83 7 21.3601 7 20.5601V18.4301C4 18.4301 2 16.4301 2 13.4301V7.42999C2 4.42999 4 2.42999 7 2.42999H17C20 2.42999 22 4.42999 22 7.42999V13.4301C22 16.4301 20 18.4301 17 18.4301Z"
        stroke="#909096"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0001 11.36V11.15C12.0001 10.47 12.4201 10.11 12.8401 9.82001C13.2501 9.54001 13.66 9.18002 13.66 8.52002C13.66 7.60002 12.9201 6.85999 12.0001 6.85999C11.0801 6.85999 10.3401 7.60002 10.3401 8.52002"
        stroke="#909096"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.9955 13.75H12.0045" stroke="#909096" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const IconAdd = ({ fill }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
        stroke="#909096"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 12H16" stroke="#909096" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 16V8" stroke="#909096" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const IconMusicwaves = ({ fill }) => {
  return (
    <svg width="366" height="522" viewBox="0 0 366 522" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="56" width="4" height="438" rx="2" fill="#0F2E79" />
      <rect x="9" y="217" width="4" height="196" rx="2" fill="#0F2E79" />
      <rect x="18" y="129" width="4" height="328" rx="2" fill="#0F2E79" />
      <rect x="27" y="185" width="4" height="244" rx="2" fill="#0F2E79" />
      <rect x="36" y="118" width="4" height="345" rx="2" fill="#0F2E79" />
      <rect x="45" y="293" width="4" height="97" rx="2" fill="#0F2E79" />
      <rect x="54" y="185" width="4" height="244" rx="2" fill="#0F2E79" />
      <rect x="63" y="64" width="4" height="426" rx="2" fill="#0F2E79" />
      <rect x="72" y="185" width="4" height="250" rx="2" fill="#0F2E79" />
      <rect x="81" y="41" width="4" height="460" rx="2" fill="#0F2E79" />
      <rect x="90" width="4" height="522" rx="2" fill="#0F2E79" />
      <rect x="100" y="45" width="4" height="454" rx="2" fill="#0F2E79" />
      <rect x="109" y="185" width="4" height="250" rx="2" fill="#0F2E79" />
      <rect x="118" y="185" width="4" height="255" rx="2" fill="#0F2E79" />
      <rect x="127" y="185" width="4" height="244" rx="2" fill="#0F2E79" />
      <rect x="136" y="122" width="4" height="339" rx="2" fill="#0F2E79" />
      <rect x="145" y="185" width="4" height="272" rx="2" fill="#0F2E79" />
      <rect x="154" y="61" width="4" height="430" rx="2" fill="#0F2E79" />
      <rect x="163" y="89" width="4" height="388" rx="2" fill="#0F2E79" />
      <rect x="172" y="105" width="4" height="364" rx="2" fill="#0F2E79" />
      <rect x="181" y="185" width="4" height="221" rx="2" fill="#0F2E79" />
      <rect x="190" y="185" width="4" height="237" rx="2" fill="#0F2E79" />
      <rect x="199" y="65" width="4" height="424" rx="2" fill="#0F2E79" />
      <rect x="208" y="185" width="4" height="267" rx="2" fill="#0F2E79" />
      <rect x="217" y="185" width="4" height="264" rx="2" fill="#0F2E79" />
      <rect x="226" y="185" width="4" height="236" rx="2" fill="#0F2E79" />
      <rect x="235" y="97" width="4" height="376" rx="2" fill="#0F2E79" />
      <rect x="244" y="92" width="4" height="384" rx="2" fill="#0F2E79" />
      <rect x="253" y="106" width="4" height="363" rx="2" fill="#0F2E79" />
      <rect x="262" y="185" width="4" height="229" rx="2" fill="#0F2E79" />
      <rect x="271" y="185" width="4" height="257" rx="2" fill="#0F2E79" />
      <rect x="281" y="88" width="4" height="390" rx="2" fill="#0F2E79" />
      <rect x="290" y="102" width="4" height="369" rx="2" fill="#0F2E79" />
      <rect x="299" y="170" width="4" height="267" rx="2" fill="#0F2E79" />
      <rect x="308" y="191" width="4" height="235" rx="2" fill="#0F2E79" />
      <rect x="317" y="173" width="4" height="262" rx="2" fill="#0F2E79" />
      <rect x="326" y="104" width="4" height="365" rx="2" fill="#0F2E79" />
      <rect x="335" y="259" width="4" height="134" rx="2" fill="#0F2E79" />
      <rect x="344" y="225" width="4" height="184" rx="2" fill="#0F2E79" />
      <rect x="353" y="113" width="4" height="353" rx="2" fill="#0F2E79" />
      <rect x="362" y="151" width="4" height="274" rx="2" fill="#0F2E79" />
    </svg>
  );
};

export const IconBlocked = ({ width, height, fill }) => {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M49.63 21.42C48.9533 20.3467 48.23 19.3433 47.4833 18.41C46.62 17.3133 44.9867 17.22 44.0067 18.2L37.0067 25.2C37.52 26.74 37.6133 28.5133 37.1467 30.3567C36.33 33.6467 33.67 36.3067 30.38 37.1233C28.5367 37.59 26.7633 37.4967 25.2233 36.9833C25.2233 36.9833 21.8867 40.32 19.4833 42.7233C18.3167 43.89 18.69 45.9433 20.2533 46.55C22.75 47.5067 25.34 47.9967 28 47.9967C32.1533 47.9967 36.19 46.7833 39.8767 44.52C43.6333 42.1867 47.0167 38.7567 49.7467 34.3933C51.9633 30.87 51.8467 24.9433 49.63 21.42Z"
        fill={fill || 'white'}
      />
      <path
        d="M32.7133 23.2867L23.2867 32.7133C22.0967 31.5 21.3267 29.82 21.3267 28C21.3267 24.3367 24.3133 21.3267 28 21.3267C29.82 21.3267 31.5 22.0967 32.7133 23.2867Z"
        fill={fill || 'white'}
      />
      <path
        d="M42.5833 13.4167L34.6733 21.3267C32.97 19.6 30.6133 18.5733 28 18.5733C22.7733 18.5733 18.5733 22.7967 18.5733 28C18.5733 30.6133 19.6233 32.97 21.3267 34.6733L13.44 42.5833H13.4167C10.8267 40.4833 8.44667 37.8 6.41667 34.6267C4.08333 30.9633 4.08333 25.0133 6.41667 21.35C9.12333 17.1033 12.4367 13.7667 16.1233 11.48C19.81 9.24 23.8467 8.00333 28 8.00333C33.2033 8.00333 38.2433 9.91667 42.5833 13.4167Z"
        fill={fill || 'white'}
      />
      <path
        d="M34.6733 28C34.6733 31.6633 31.6867 34.6733 28 34.6733C27.86 34.6733 27.7433 34.6733 27.6033 34.6267L34.6267 27.6033C34.6733 27.7433 34.6733 27.86 34.6733 28Z"
        fill={fill || 'white'}
      />
      <path
        d="M50.7967 5.20333C50.0967 4.50333 48.9533 4.50333 48.2533 5.20333L5.20333 48.2767C4.50333 48.9767 4.50333 50.12 5.20333 50.82C5.55333 51.1467 5.99667 51.3333 6.46333 51.3333C6.93 51.3333 7.37333 51.1467 7.72333 50.7967L50.7967 7.72333C51.52 7.02333 51.52 5.90333 50.7967 5.20333Z"
        fill={fill || 'white'}
      />
    </svg>
  );
};

export const Telegram = ({ width, height, fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="16" fill="#3390EC" />
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="m8.1 14.596 8.592-3.628C20.783 9.299 21.634 9.01 22.188 9c.122-.002.394.028.57.168.15.119.19.279.21.391.02.113.044.369.025.569-.222 2.284-1.181 7.826-1.67 10.385-.206 1.082-.612 1.445-1.006 1.48-.856.078-1.505-.554-2.334-1.086l-3.288-2.166c-1.455-.94-.512-1.456.317-2.3.217-.221 3.987-3.583 4.06-3.888.009-.038.018-.18-.069-.255-.086-.075-.213-.05-.305-.029-.13.029-2.201 1.371-6.214 4.027-.588.396-1.12.589-1.598.579-.526-.011-1.538-.292-2.29-.532-.923-.294-1.656-.45-1.592-.948.033-.26.398-.527 1.096-.798Z"
        clip-rule="evenodd"
      />
    </svg>
  );
};

export const Pinterest = ({ width, height, fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="16" fill="#E60023" />
      <path
        fill="#fff"
        d="M16.522 9.232c-3.874 0-5.831 2.739-5.831 5.022 0 1.386.532 2.611 1.668 3.071.189.078.355.006.41-.2.04-.138.211-.498.25-.642.055-.2.033-.272-.116-.45-.328-.382-.533-.78-.533-1.48 0-2.327 1.453-3.985 3.925-3.985 2.19 0 3.392 1.358 3.392 3.121 0 2.317-1.042 4.202-2.588 4.202-.854 0-1.491-.621-1.286-1.475.244-1.02.72-2.117.72-2.854 0-.66-.355-1.131-1.097-1.131-.87 0-1.575.815-1.575 2.006 0 .76.25 1.137.25 1.137s-.881 3.863-1.042 4.517c-.31 1.303-.045 2.894-.022 3.054.01.095.138.117.194.045.077-.1 1.12-1.37 1.474-2.633.1-.355.577-2.206.577-2.206.282.532 1.114.875 1.99.875 2.621 0 4.4-2.233 4.4-5.382.006-2.389-2.045-4.612-5.16-4.612Z"
      />
    </svg>
  );
};

// export const IconTwitter = ({ width, height, className, fill }) => {
//   return (
//     <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" style="enable-background:new 0 0 512 512">
//       <path
//         d="M512 97.248c-19.04 8.352-39.328 13.888-60.48 16.576 21.76-12.992 38.368-33.408 46.176-58.016-20.288 12.096-42.688 20.64-66.56 25.408C411.872 60.704 384.416 48 354.464 48c-58.112 0-104.896 47.168-104.896 104.992 0 8.32.704 16.32 2.432 23.936-87.264-4.256-164.48-46.08-216.352-109.792-9.056 15.712-14.368 33.696-14.368 53.056 0 36.352 18.72 68.576 46.624 87.232-16.864-.32-33.408-5.216-47.424-12.928v1.152c0 51.008 36.384 93.376 84.096 103.136-8.544 2.336-17.856 3.456-27.52 3.456-6.72 0-13.504-.384-19.872-1.792 13.6 41.568 52.192 72.128 98.08 73.12-35.712 27.936-81.056 44.768-130.144 44.768-8.608 0-16.864-.384-25.12-1.44C46.496 446.88 101.6 464 161.024 464c193.152 0 298.752-160 298.752-298.688 0-4.64-.16-9.12-.384-13.568 20.832-14.784 38.336-33.248 52.608-54.496z"
//         fill={fill || 'white'}
//         xmlns="http://www.w3.org/2000/svg"
//       />
//     </svg>
//   );
// };

export const SnapchatIcon = ({ width, height, fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none">
      <circle cx="16" cy="16" r="16" fill="#ECE900" />
      <path
        fill="#fff"
        stroke="#1A1A1A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".4"
        d="M15.991 22.302c1.319 0 2.305-.971 2.305-.971.087-.073.185-.142.185-.142.79-.518 2.069-.145 2.069-.145.465.11.478-.24.478-.24l.036-.399c.034-.39.634-.386.634-.386.79-.03 1.122-.354 1.26-.582.146-.22-.132-.281-.132-.281-1.905-.532-2.83-2.34-2.83-2.34-.43-.757.16-1.062.16-1.062.159-.113.94-.37.94-.37.645-.259.43-.707.43-.707-.239-.483-.797-.161-.797-.161-.264.14-.462.128-.462.128-.44.009-.494-.086-.494-.086l.015-2.093C19.788 10.552 18.1 9 16.018 9h-.036c-2.083 0-3.77 1.552-3.77 3.465l.015 2.093s-.053.095-.494.086c0 0-.199.012-.463-.128 0 0-.557-.322-.797.16 0 0-.214.45.43.708 0 0 .782.257.941.37 0 0 .59.305.16 1.061 0 0-.924 1.809-2.83 2.341 0 0-.278.062-.131.28.137.229.47.552 1.259.583 0 0 .6-.004.634.386l.036.398s.013.351.478.241c0 0 1.28-.373 2.069.145 0 0 .098.07.185.142 0 0 .986.97 2.305.97h-.018Z"
      />
    </svg>
  );
};
